import React, { useState, useEffect, Component } from 'react';
import firebase, { messaging }from './firebase'
import MainDrawer from './Components/Drawer'
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Privacy from './Components/Privacy'
import Login from'./Components/Login'

import boopSfx from './sound.mp3';
import UIfx from 'uifx';

const alertSound = new UIfx(boopSfx)
const subscribeToAdmin = firebase.functions().httpsCallable("subscribeToAdmin");

const App = () => {
  const [user, setUser] = useState("load")

  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
        setUser(user ? user : null)
    })

    if (firebase.messaging.isSupported()) {
      Notification.requestPermission()
        .then(async function () {
          const token = await messaging.getToken();
          console.log("Token: ", token);
          subscribeToAdmin({ token: token }).then(function (result) {
            console.log(result);
          });
        })
        .catch(function (err) {
          console.log("Unable to get permission to notify.", err);
        });

      navigator.serviceWorker.addEventListener("message", (message) => {
        console.log(message)
        alertSound.play(1.0)
      });
    }

    return () => {
      // cleanup
    }
  }, [])


  return (
    <Router>
      <Switch>
        <Route path='/download' component={() => { 
            window.location.href = 'http://onelink.to/w4d2wn'; 
            return null;
        }}/>
        <Route path="/privacy">
          <Privacy/>
        </Route>
        <Route path="/">
          {user === "load" ? null : user ? (<MainDrawer />) : (<Login />)}
        </Route>
      </Switch>
    </Router>
  )
}

// class App extends Component {

//   constructor(props) {
//     super(props);
//     this.state = {
//       user: "load"
//     }
//   }

//   componentDidMount() {
//     this.authListener();
//     // var createOrder = firebase.functions().httpsCallable('createOrder');
//     // createOrder({cart: ["item1", "item2"], type: "online", amount: 250}).then(function (result) {
//     //   console.log(result)
//     // });

//     // var confirmOrder = firebase.functions().httpsCallable('confirmOrder');
//     // confirmOrder({ order_id: "-M5xhldpKMcRFYrQOtpD", razorpay_order_id: "order_EjfiTk9sUuQ6zt", razorpay_payment_id: "pay_Ejftma77Pl5INX"}).then(function (result) {
//     //   console.log(result)
//     // });
//   }

//   authListener() {
//     firebase.auth().onAuthStateChanged((user) => {
//       if (user) {
//         this.setState({ user })
//       }
//       else {
//         this.setState({ user: null })
//       }
//     })
//   }

//   render() {
//     const { user } = this.state
//     return (
//       <Router>
//         <Switch>
//           <Route path='/download' component={() => { 
//               window.location.href = 'http://onelink.to/w4d2wn'; 
//               return null;
//           }}/>
//           <Route path="/privacy">
//             <Privacy/>
//           </Route>
//           <Route path="/">
//             {user === "load" ? null : user ? (<MainDrawer />) : (<Login />)}
//           </Route>
//         </Switch>
//       </Router>
//     )
//   }
// }

export default App;
